import ajax from "../../authenticationSafeAjax";
import {authenticatedUser} from "../models";

const AUTH_API_URL = "/recorder/api/auth";

export function authenticate(username, password, onSuccess, onError) {
    ajax({
        url: AUTH_API_URL,
        method: "POST",
        body: `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`
    }, (code) => {
        if (code === 200 || code === 204) {
            onSuccess();

        } else {
            onError();
        }
    });
}

export function requestRecorderAuthenticationStatus(callback) {
    ajax({ url: AUTH_API_URL }, (code, response) => {
        const userInfo = authenticatedUser(JSON.parse(response));

        callback(userInfo);
    });
}




/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/actions/authenticationRequests.js
 **/